import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const shopBannerApi = createAsyncThunk(
  "shopBanner",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/admin_panel/web_banner");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const shopBannerSlice = createSlice({
  name: "shopBanner",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shopBannerApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(shopBannerApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(shopBannerApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export default shopBannerSlice.reducer;
